import { render } from "./ResponsibilityList.vue?vue&type=template&id=45e049a3"
import script from "./ResponsibilityList.vue?vue&type=script&lang=js"
export * from "./ResponsibilityList.vue?vue&type=script&lang=js"

import exportComponent from "F:\\jenkins\\data\\workspace\\ZYZB\\zyzb-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__